export const setWindowTemplates = (fileName, handlebar) => {
    window.B.Templates[`${fileName}.hbs`] = handlebar;
};
